import { create } from '@bufbuild/protobuf';

import {
  CallParticipant_Role,
  InitialParticipant,
  InitialParticipantSchema,
} from 'APP/wsApi/wsAppApi/types/call/call_model_pb';
import { CallFinishReason } from 'APP/wsApi/wsAppApi/types/common/common_model_pb';

import { CallParticipantRole, FinishReasons, ICallinitialParticipant } from './mainCallModel.types';

const finishReason: Record<CallFinishReason, FinishReasons> = {
  [CallFinishReason.CFR_FINISHED]: FinishReasons.Finished,
  [CallFinishReason.CFR_DECLINED]: FinishReasons.Declined,
  [CallFinishReason.CFR_UNANSWERED]: FinishReasons.Unanswered,
};

export function mapCallFinishReason(reason: CallFinishReason): FinishReasons {
  return finishReason[reason];
}

const callParticipantRoleMap: Record<CallParticipantRole, CallParticipant_Role> = {
  [CallParticipantRole.Superuser]: CallParticipant_Role[CallParticipantRole.Superuser],
  [CallParticipantRole.Member]: CallParticipant_Role[CallParticipantRole.Member],
  [CallParticipantRole.Guest]: CallParticipant_Role[CallParticipantRole.Guest],
};

export function mapInitialParticipants(
  participants: ICallinitialParticipant[]
): InitialParticipant[] {
  return participants.map((participant) => {
    return create(InitialParticipantSchema, {
      userId: BigInt(participant.userId),
      role: participant.role ? callParticipantRoleMap[participant.role] : undefined,
    });
  });
}
